<div class="registration-layout" [class.registration-layout-plain]="isWelcomePage">
  <img *ngIf="!isWelcomePage" alt="" [src]="'logos/logo-secondary.svg' | contentAssetImage" 
   class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
